export const advertisersTranslationKeys = {
  advertiserXXX: 'advertisers.xxx',
}
